import './BenefitsCard.scss';

import React from 'react';

function BenefitsCard({ className, children }) {
  return (
    <div className={`benefits-card ${className ? className : ''}`}>
      {children}
    </div>
  );
}

export default BenefitsCard;
